export enum CheckoutGaCategory {
  Pages = 'checkout-pages',
}
